/*
ADD THIS TO YOUR METHODS IN COMPONENTS
  methods: {
      hello () {
        this.$helpers.konsol('Hello From Helpers')
      }
  }
*/
import moment from 'moment'

const userLocale = window.USER && window.USER.language ? window.USER.language : 'da'

export default {
  install: (Vue) => {
    Vue.prototype.$helpers = {
      konsol (e) {
        // this.$helpers.konsol('Hello From Helpers')
        console.log('$helpers', e)
      },
      sortArrOnName (arr) {
        // filter out items that start with '(' sort them and add them to the bottom
        const usersWithoutSpecialCase = arr.filter(item => item.name && !item.name.startsWith('('))
        const usersSorted = usersWithoutSpecialCase.sort((a, b) => {
          return a.name.localeCompare(b.name, userLocale, {
            numeric: true,
            sensitivity: 'base'
          })
        })
        const usersWithSpecialCharacters = arr.filter(item => item.name && item.name.startsWith('('))
        const usersWithSpecialCharactersSorted = usersWithSpecialCharacters.sort((a, b) => {
          return a.name.localeCompare(b.name, userLocale, {
            numeric: true,
            sensitivity: 'base'
          })
        })
        return usersSorted.concat(usersWithSpecialCharactersSorted)
      },
      filterEventsOnDate (events, date) {
        return events.filter(event => {
          return moment(event.start_time).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
        })
      },
      sortEventsOnDateTime (events) {
        let arr = events
        return arr.sort((a, b) => {
          return moment(a.start_time).unix() - moment(b.start_time).unix()
        })
      },
      eventsSortedInDaysArray (events) {
        return events.reduce((acc, curr, index) => {
          var val = moment(curr['start_time']).format('YYYY-MM-DD')
          acc[val] = acc[val] || []
          acc[val].push(curr)
          return acc
        }, {})
      },
      eventsPackedInDays (events) {
        return Object.keys(events).map(e => {
          return {date: e, events: events[e]}
        })
      },
      checkUserDevice () {
        let isMobile = (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        if (isMobile) {
          return 'Mobile'
        } else if ((/iPad/i.test(navigator.userAgent))) {
          return 'IPad'
        } else {
          return 'Desktop'
        }
      },
      setSessionStorage (name, val) {
        try {
          if (typeof (Storage) !== 'undefined') {
            window.sessionStorage[name] = val
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      getSessionStorage (name) {
        try {
          if (typeof (Storage) !== 'undefined') {
            if (window.sessionStorage.getItem(name) !== null) {
              return window.sessionStorage.getItem(name)
            }
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      setLocalStorage (name, val) {
        try {
          if (typeof (Storage) !== 'undefined') {
            window.localStorage.setItem(name, val)
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      getLocalStorage (name) {
        try {
          if (typeof (Storage) !== 'undefined') {
            if (window.localStorage.getItem(name) !== null) {
              return window.localStorage.getItem(name)
            }
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      removeLocalStorage (name) {
        try {
          if (typeof (Storage) !== 'undefined') {
            if (window.localStorage.getItem(name) !== null) {
              return window.localStorage.removeItem(name)
            }
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      getCookie (cname) {
        var name = cname + '='
        var decodedCookie = decodeURIComponent(document.cookie)
        var ca = decodedCookie.split(';')
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ''
      },
      setCookie (cname, cvalue) {
        var days = 100
        var expires = ''
        if (days) {
          var date = new Date()
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
          expires = '; expires=' + date.toUTCString()
        }
        document.cookie = cname + '=' + (cvalue || '') + expires + '; path=/'
      },
      deleteCookie (cname) {
        document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      },
      sendCustomEvt (evtName, val) {
        var evt = new window.CustomEvent(evtName, {detail: val})
        window.dispatchEvent(evt)
      },
      hashMap (arr, key) {
        const filteredArr = arr.filter(item => item[key])
        if (!key) {
          return filteredArr.reduce((obj, item) => {
            obj[item.id] = item
            return obj
          }, {})
        } else {
          return filteredArr.reduce((obj, item) => {
            obj[item[key]] = item
            return obj
          }, {})
        }
      },
      expandTimeRangeForEvents (startTime, endTime, events) {
        // Udvider (men formindsker aldrig) et 'HH:mm:ss'-tidsrum, så det rummer
        // alle events i den viste uge. Bruges til at lade kalenderen automatisk
        // strække sig når et møde ligger uden for det valgte preset-tidsrum.
        let startHour = parseInt(String(startTime).slice(0, 2), 10)
        let endHour = parseInt(String(endTime).slice(0, 2), 10)
        const pad = n => String(n).padStart(2, '0')
        if (!Array.isArray(events)) {
          return { startTime, endTime }
        }
        events.forEach(ev => {
          if (!ev || !ev.start || !ev.end) return
          const start = moment(ev.start)
          const end = moment(ev.end)
          if (!start.isValid() || !end.isValid()) return
          const eventStartHour = start.hours()
          // Rund op hvis mødet slutter midt i en time, så hele mødet er synligt
          let eventEndHour = end.hours() + ((end.minutes() > 0 || end.seconds() > 0) ? 1 : 0)
          if (eventStartHour < startHour) startHour = eventStartHour
          if (eventEndHour > endHour) endHour = eventEndHour
        })
        startHour = Math.max(0, Math.min(startHour, 23))
        endHour = Math.max(startHour, Math.min(endHour, 23))
        return {
          startTime: pad(startHour) + ':00:00',
          endTime: pad(endHour) + ':00:00'
        }
      },
      calcLessonsPerWeek (hours, subjectDefaultDuration, schoolYearWeeks) {
        if (!hours) return '0.0'
        const total = Math.abs(hours)
        const weeks = schoolYearWeeks != null && schoolYearWeeks > 0 ? schoolYearWeeks : 40
        const lessonsPerWeek = weeks * ((subjectDefaultDuration || 45) / 60)
        const raw = total / lessonsPerWeek
        const rounded = Math.round(raw * 10) / 10
        const sign = hours < 0 ? '-' : ''
        return sign + rounded.toFixed(1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/general-helpers.js